<template>
  <header class="header">
    <div class="header-top">
      <div class="comWidth">
        <div v-if="!token" class="left">歡迎光臨極草線上商城</div>
        <router-link  v-if="token"  class="left" :to="{name:'PersonCenter'}"  tag="a" >歡迎光臨極草線上商城</router-link>
        <div class="right">
          <router-link :to="{name:'ConsumerNotification',query:{id:3}}" tag="a">消費者告知書</router-link>
          <span>|</span>
          <!--<a>在線客服</a>-->
          <a onclick="NTKF.im_openOutPageChat('kf_9013_1496720234390')">在線客服</a>
          <span>|</span>
          <a @click="judgeLogin_a">個人中心</a>
          <span>|</span>
          <!--<a @click="judgeLogin_b">充值中心</a>-->
          <!--<span>|</span>-->
          <router-link :to="{name:'SignIn'}" tag="a" v-if="!token">登錄註冊</router-link>
          <a v-if="token" @click="tokenOut">安全退出</a>
        </div>
      </div>
    </div>
    <div class="header-bottom">
      <div class="comWidth">
        <a href="/">
          <!--<img src="../assets/logo.png" alt="极草商城" class="logo fl">-->
          <img :src="cfg_shop_logo" alt="极草商城" class="logo fl">
        </a>
        <ul >
          <li v-for="item in titleChild" :key='item.id'>
            <router-link :to="{name:item.src,query:{id:item.id}}"  tag="a">{{item.name}}</router-link>
          </li>
          <a class="shop-car" @click="goCar">
            <img src="../assets/shopcar-icon.png">
            購物車
          </a>

        </ul>
      </div>
    </div>
  </header>
</template>

<script>

  import { getToken } from '@/utils/auts'
  import { mapGetters } from 'vuex'
  //common.js
  import {getLocalStorage,setLocalStorage , ifSignIn} from '@/utils/common';
  //api
  import {configs } from '@/api/other';
//  import {articlesDetails} from '@/api/article';
  import {userInformation} from '@/api/authentication';
  export default {
    name: 'Header',
    data () {
      return {
        titleChild: [
          {name: '首頁', src: 'HomePage',id:undefined},
          {name: '澳門極草', src: 'MacaoPage',id:5},
          {name: '極草產品', src: 'ProductPage',id:undefined},
          {name: '極草資訊', src: 'InformationPage',id:undefined},
          {name: '冬蟲夏草', src: 'CordycepsSinensis',id:undefined},
          {name: '服務門店', src: 'ServiceStore',id:undefined}
        ],
        configsMsgHeader:{},
        cfg_shop_name:'极草产品-极草线上商城',//title
        cfg_shop_keywords:'极草产品页面提供极草产品相关信息，极草5X冬虫夏草纯粉片（经典含片）',//key
        cfg_shop_desc:'澳门极草,极草线上商城,极草5X冬虫夏草',//dec
        cfg_shop_logo:'',//dec
        titleS:'', // 消费者告知书
        NTKF_PARAM:{
          siteid:"kf_9013",               //企业ID，为固定值，必填
          settingid:"kf_9013_1496720234390",  //接待组ID，为固定值，必填
          uid:"",                    //用户ID，未登录可以为空，但不能给null，uid赋予的值显示到小能客户端上
          uname:"",        //用户名，未登录可以为空，但不能给null，uname赋予的值显示到小能客户端上
          isvip:"0",                          //是否为vip用户，0代表非会员，1代表会员，取值显示到小能客户端上
          itemid:"9",       //商品ID
          userlevel:"1",                    //网站自定义会员级别，0-N，可根据选择判断，取值显示到小能客户端上
          erpparam:"abc"                      //erpparam为erp功能的扩展字段，可选，购买erp功能后用于erp功能集成
        }
      }
    },
    metaInfo() {
          return {
            title: this.cfg_shop_name, // set a title
            meta: [
                {                 // set meta
              name: 'Keywords',
              content: this.cfg_shop_keywords
            },
              {                 // set meta
              name: 'Description',
              content: this.cfg_shop_desc
            },
          ],
         /*   link: [{                 // set link
              rel: 'asstes',
              href: 'https://assets-cdn.github.com/'
            }]*/
//            is_validated:undefined
          }
    },
    methods: {
      goCar(){
        ifSignIn(this, () =>{
            this.getInformation()
          if (this.is_validated == 0) { //判断是否实名认证
            this.$confirm('您還未實名認證，是否前往實名認證?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              lockScroll:false,
            }).then(() => {
              this.$router.push({name: 'RealName'});
            }).catch(() => {
            });
          } else {
            this.$router.push({name: 'ShoppingCart'});
          }
        })
      },
      /*获取登陆后的个人信息*/
      getInformation(){
        if (getToken()){
          userInformation().then(res =>{
            this.is_validated = res.data.is_validated;
          })
        }
      },
      //判断是否登录
      tokenOut(){
        this.$store.dispatch('LogOut').then(() => {
          this.$message.success('退出成功');
            this.$router.push({
              name:'SignIn'
            })
        }).catch(() => {});
      },
      /*获取协议内容*/
/*      getAgreementYong(){
//        var params = {
//          article:3
//        }
        articlesDetails(3).then(res =>{
          this.titleS = res.data.title;
        })
      },*/

    judgeLogin_a(){
        //判断是否登录
        ifSignIn(this, () =>{
          this.$router.push({name:'PersonCenter'});
        })
    },
    judgeLogin_b(){
      //判断是否登录
      ifSignIn(this, () =>{
        this.$router.push({name:'AccountRecharge'});
      })
    },
      /*获取平台信息*/
    getConfigs(){
      var MSG = JSON.parse(sessionStorage.getItem('configsMsgHeader'));
      if (!MSG){
        configs().then(res =>{
          this.configsMsgHeader = res.data;
          this.cfg_shop_logo =  this.configsMsgHeader.cfg_shop_logo;
          this.cfg_shop_name =  this.configsMsgHeader.cfg_shop_name;
          this.cfg_shop_keywords =  this.configsMsgHeader.cfg_shop_keywords;
          this.cfg_shop_desc =  this.configsMsgHeader.cfg_shop_desc;
          sessionStorage.setItem('configsMsgHeader' , JSON.stringify( this.configsMsgHeader))
        })
      }
    },
      getMSG(){
        getLocalStorage('configsMsgHeader' , res =>{
          this.configsMsgHeader = res;
          this.cfg_shop_name =  this.configsMsgHeader.cfg_shop_name;
          this.cfg_shop_keywords =  this.configsMsgHeader.cfg_shop_keywords;
          this.cfg_shop_desc =  this.configsMsgHeader.cfg_shop_desc;
          this.cfg_shop_logo =  this.configsMsgHeader.cfg_shop_logo;
        })
      },
  },
    computed: {
      ...mapGetters([
        'token'
      ]),
    },
    created(){
      //获取平台信息
      this.getConfigs();
      this.getMSG();
//      this.getAgreementYong();
    },
    watch : {
      '$route':{
        deep: true,
        handler: function(to, from){
          this.getMSG();
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "../css/header.less";
</style>



// WEBPACK FOOTER //
// src/components/Header.vue